"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function unixTime(date) {
    return Math.round((date !== null && date !== void 0 ? date : new Date()).getTime() / 1000);
}
exports.default = unixTime;
